// ToDo review if this file should go here or a helpers folder
export const anySerializer = {
  read: (v: any) => (v ? JSON.parse(v) : null),
  write: (v: any) => JSON.stringify(v),
};
